import {IO, io} from 'fp-ts/lib/IO';

export const fromLocalStorage = (localStorageKey: LocalStorageKey): IO<string | null> => () =>
  localStorage.getItem(localStorageKey);

export const toLocalStorage = (key: string) => (value: any) => () => localStorage.setItem(key, value);

export const removeFromLocalStorage = (key: string) => () => localStorage.removeItem(key);

export const fromSessionStorage = (localStorageKey: LocalStorageKey): IO<string | null> => () =>
  sessionStorage.getItem(localStorageKey);

export const toSessionStorage = (key: string) => (value: any) => () => sessionStorage.setItem(key, value);

export enum LocalStorageKey {
  initialSelectedAgency = 'initialSelectedAgency',
  IsEmployee = 'is_employee',
  Claims = 'claims',
  State = 'state',
  ExpiresAt = 'expires_at',
  AccessToken = 'access_token',
  AlertsDismissed = 'alerts_dismissed',
  IndependentAgentRegistrationKey = 'independent_agent_registration_key',
  PagedViewVisibilityPreferences = 'paged_view_visibility_preferences',
  AWDCsrfToken = 'awd_csrf_token',
  AWDDSTSession = 'awd_dst_session',
  RedirectRoute = 'redirectRoute',
  OpportunityId = 'opportunityId',
  LastActive = 'lastActive',
  CustomerName = 'customerName',
}

export const withValueSavedToLocalStorage = (ioOperation: IO<string>) => (storageKey: LocalStorageKey) =>
  io.chain(ioOperation, value => io.map(toLocalStorage(storageKey)(value), io.of(value)));
